import type { CustomIconProps } from '../CustomIcon';

export function StarIcon({
  color = '#D8601E',
  secondaryColor,
  ternaryColor,
  solid,
  size = 24,
  ...props
}: CustomIconProps) {
  return (
    <svg width={size} height={size} viewBox='0 0 10 10' fill='none' {...props}>
      <path
        d='M5 0L6.545 3.13L10 3.635L7.5 6.07L8.09 9.51L5 7.885L1.91 9.51L2.5 6.07L0 3.635L3.455 3.13L5 0Z'
        fill={solid ? color : undefined}
        stroke={solid ? undefined : color}
        strokeWidth={0.75}
      />
    </svg>
  );
}
